export const BULK_UPDATE_FULFILLMENT_PLAN_ID = 'bulk-update';
